module.exports = __webpack_public_path__ + "img/banner.9fbc5c63.png";